import React from "react";
import { QRCode } from '../qrcode'
import PointBase from "./Base/PointBase";
import { pointOptions } from "./ultil";


/**
 * @QrProvider(
 *   id = "star",
 *   title = @Translation("Star")
 * )
 */
export default class RendererStar extends PointBase {

	/**
	 * constructor
	 * @param $options
	 * @param $qrcode
	 * @param $name
	 */
	constructor($options: any = {}, $qrcode: QRCode, $name?: string) {
		const pointRender = ($options: any) => {
			let $opts = pointOptions($options, ['transform'], [],
				function ($opts: any){
					let { x, y, scale } = $opts || {};
					return Object.assign($opts, { "transform": `translate(${x},${y}) scale(${scale})` });
				});
			return <g>
				<path {...$opts} fillRule="evenodd" clipRule="evenodd"
				      d="M55.7149 110.855C51.1653 77.4659 32.0792 60.406 0.353027 55.7992C32.3124 51.7325 50.7231 34.1743 55.7358 0.855347C60.5802 33.291 78.7335 51.1154 110.353 55.8278C78.5344 60.505 60.7177 78.4966 55.7149 110.855Z"/>
			</g>;
		}
		
		Object.assign($options, {pos: pointRender})
		
		super($options, $qrcode, $name || 'RendererStar');
	}
}
